<template>

    <app-base-main parentTable>
      <template #filter-group>
        <app-filter-group
            @query="$gjNoticeQuery"
            @reset="$gjReset">
          <gj-search-input
              v-model="filter.name"
              width="200px"
              placeholder="请输入名称"
          ></gj-search-input>
          <gj-select
              v-model="filter.status"
              :options="ProductBrandEnum.stateOption"
              placeholder="状态"
          ></gj-select>
          <gj-creator-select
              v-model="filter.createUserId"
              placeholder="创建人"
          ></gj-creator-select>
          <gj-tooltip content="创建时间">
            <gj-date-picker
                v-model="filter.createDate"
                type="daterange"
            ></gj-date-picker>
          </gj-tooltip>
        </app-filter-group>
      </template>
      <template #operate-group>
        <gj-button v-if="$permission('brand:add')" type="primary" @click="addBrand">添加</gj-button>
        <gj-button
            v-if="$permission('brand:delete')"
            :disabled="noSelect || selectedSomeIs('isRelatedSku', true)"
            @click="deleteBrand(selectedRows)">
          批量删除
        </gj-button>
        <template v-if="$permission('brand:edit')">
          <gj-button
              :disabled="!selectedAllIs('state', ProductBrandEnum.status.ACTIVE)"
              @click="inactiveBrand(selectedRows)">
            批量停用
          </gj-button>
          <gj-button
              :disabled="!selectedAllIs('state', ProductBrandEnum.status.INACTIVE)"
              @click="activeBrand(selectedRows)">
            批量启用
          </gj-button>
        </template>
      </template>
      <template #tool-group>
        <gj-tool-group
            log @viewLog="viewLog"
            :download="$permission('brand:export')" download-url="/supply/brand/export" :download-params="globalParams"
            help
        ></gj-tool-group>
      </template>
      <template #table>
        <gj-table
            ref="gjTable"
            adaptParent
            name="productBrand"
            :loading="loading"
            :data="tableData"
            :columns="columns"
            :selection="$permission(['brand:delete', 'brand:edit'])"
            sortable="custom"
            :pagination="pagination"
            :default-sort="{prop: 'createTime', order: 'descending'}"
            @sort-change="$gjSortChange"
            @page-change="$gjNoticeQuery">

          <template v-slot:state="{row}">
            <gj-tag type="text" style="margin-right: 10px" shape="rectangle"
                    :color="row.state | optionColor(ProductBrandEnum.stateOption)">
              {{ row.state | optionText(ProductBrandEnum.stateOption) }}
            </gj-tag>
          </template>

          <template v-slot:op="{ index, row }">
            <gj-button-group type="dropdown-op" v-if="$permission('brand:delete') || $permission('brand:edit')">
              <template v-if="$permission('brand:edit')">
                <gj-button type="text" @click="editBrand(row)">编辑</gj-button>
                <gj-button
                    v-if="row.state === ProductBrandEnum.status.INACTIVE"
                    type="text"
                    @click="activeBrand([row])">
                  启用
                </gj-button>
                <gj-button
                    v-if="row.state === ProductBrandEnum.status.ACTIVE"
                    type="text"
                    @click="inactiveBrand([row])">
                  停用
                </gj-button>
              </template>
              <gj-tooltip
                  v-if="$permission('brand:delete')"
                  :content="row.isRelatedSku ? '已关联产品，无法删除' : null">
                <gj-button
                    type="text"
                    :disabled="row.isRelatedSku"
                    @click="deleteBrand([row])">
                  删除
                </gj-button>
              </gj-tooltip>
            </gj-button-group>
          </template>
        </gj-table>
      </template>
    </app-base-main>
</template>

<script>
  import AppProductBrandAddModal from "./modal/product-brand-add-modal";
  import AppProductBrandEditModal from "./modal/product-brand-edit-modal";
  import {ProductBrandEnum} from "./enum";
  import {queryMixin, selectionMixin} from "../../../../minxins";
  import {defaultVal, isMeaningful} from "../../../../utils/common";
  import {convertToDate} from "../../../../utils/date.util";
  import {deleteProductBrand, disableOrEnableProductBrand, getProductBrandPage} from "../../../../api/product";
  import {exportFile} from "../../../../api/common";
  import {PRODUCT_GET_PRODUCT_BRAND} from "../../../../store/action-types";

  export default {
    name: "app-product-brand",
    mixins: [queryMixin, selectionMixin],
    created() {
      this.sort.prop = 'createTime';
    },
    data() {
      return {
        tableData: [],
        columns: [
          {id: 'name', header: '品牌名称', field: 'name', minWidth: '100px', overflowLine: 2, copyable: true},
          {id: 'memo', header: '描述', field: 'memo', minWidth: '200px', overflowLine: 2},
          {
            id: 'state',
            header: '状态',
            field: 'slot:state',
            options: ProductBrandEnum.stateOption,
            minWidth: '60px',
            sortable: true
          },
          {id: 'createUserName', header: '创建人', field: 'createUserName', minWidth: '100px'},
          {id: 'createTime', header: '创建时间', field: 'createTime', minWidth: '200px', sortable: true},
          {id: 'op', header: '操作', field: 'slot:op', width: '150px', fixed: 'right', notCustomColumn: true},
        ],
        filter: {
          name: null,
          createDate: null,
          createUserId: null,
          status: ProductBrandEnum.status.ACTIVE
        },
        ProductBrandEnum: ProductBrandEnum,
        globalParams: {},
        notStorage: true
      }
    },
    methods: {
      $gjQueryInitParams() {
        return {
          filter: {
            name: null,
            createDate: null,
            createUserId: null,
            status: ProductBrandEnum.status.ACTIVE
          }
        };
      },
      $gjQuery() {
        // 构造查询参数
        const params = {
          model: {
            createUserId: defaultVal(this.filter.createUserId, null),
            name: this.filter.name,
            state: defaultVal(this.filter.status, null),
            startCreateTime: this.filter.createDate ? convertToDate(this.filter.createDate[0]) : null,
            endCreateTime: this.filter.createDate ? convertToDate(this.filter.createDate[1]) : null,
          },
          ...this.queryPagination,
          ...this.querySort
        };
        this.globalParams = params;
        // 查询
        this.loading = true;
        getProductBrandPage(params)
          .then((data) => {
            if (isMeaningful(data)) {
              this.tableData = data.records;
              this.pagination = this.getPagination(data);
            } else {
              this.tableData = [];
            }
          })
          .complete(() => {
            this.loading = false;
          });
      },
      viewLog() {
        this.$gjCreate('gj-log-modal', {
          props: {
            url: '/supply/brand/logPage',
            opTypeOption: [
              {id: 'Enable', text: '启用'},
              {id: 'Disable', text: '停用'},
              {id: 'Add', text: '添加'},
              {id: 'Delete', text: '删除'},
              {id: 'Update', text: '更新'},
            ]
          }
        });
      },
      addBrand() {
        this.$gjCreate(AppProductBrandAddModal, {
          on: {
            created: () => {
              this.$gjMessage.success('添加成功');
              this.$gjResetPage();
              this.refreshStoreBrand();
            }
          },
        });
      },
      refreshStoreBrand() {
        this.$store.dispatch(PRODUCT_GET_PRODUCT_BRAND);
      },
      editBrand(brand) {
        this.$gjCreate(AppProductBrandEditModal, {
          props: {
            brand: brand,
          },
          on: {
            updated: () => {
              this.$gjMessage.success('更新成功');
              this.$gjResetPage();
              this.refreshStoreBrand();
            }
          },
        });
      },
      deleteBrand(rows) {
        const modal = this.$gjCreate("gj-info-modal", {
          props: {
            title: '删除确认',
            content: rows.length === 1
              ? `确定要删除[${rows[0].name}]吗？一旦删除不可恢复，请谨慎操作！`
              : `已选中 ${rows.length} 个品牌，确定要批量删除吗？一旦删除不可恢复，请谨慎操作！`,
          },
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm: () => {
              modal.confirmLoading = true;
              deleteProductBrand({
                ids: rows.map(e => e.id)
              })
                .then(() => {
                  this.$gjMessage.success('操作成功');
                  this.$gjResetPage();
                  modal.$gjDestroy();
                  this.refreshStoreBrand();
                })
                .complete(() => modal.confirmLoading = false);
            }
          },
        });
      },
      inactiveBrand(rows) {
        const modal = this.$gjCreate("gj-info-modal", {
          props: {
            title: '停用确认',
            content: rows.length === 1 ? `确定要停用[${rows[0].name}]吗？` : `已选中 ${rows.length} 个品牌，确定要批量停用吗？`,
          },
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm: () => {
              modal.confirmLoading = true;
              disableOrEnableProductBrand({
                ids: rows.map(e => e.id),
                state: ProductBrandEnum.status.INACTIVE
              })
                .then(() => {
                  this.$gjMessage.success('操作成功');
                  this.$gjResetPage();
                  modal.$gjDestroy();
                  this.refreshStoreBrand();
                })
                .complete(() => modal.confirmLoading = false);
            }
          },
        });
      },
      activeBrand(rows) {
        const modal = this.$gjCreate("gj-info-modal", {
          props: {
            title: '启用确认',
            content: rows.length === 1 ? `确定要启用[${rows[0].name}]吗？` : `已选中 ${rows.length} 个品牌，确定要批量启用吗？`,
          },
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm: () => {
              modal.confirmLoading = true;
              disableOrEnableProductBrand({
                ids: rows.map(e => e.id),
                state: ProductBrandEnum.status.ACTIVE
              })
                .then(() => {
                  this.$gjMessage.success('操作成功');
                  this.$gjResetPage();
                  modal.$gjDestroy();
                  this.refreshStoreBrand();
                })
                .complete(() => modal.confirmLoading = false);
            }
          },
        });
      }
    }
  }
</script>

<style scoped>

</style>
